<template>
  <router-view />
</template>

<script>
export default {
  name: 'AppWrapper'
}
</script>

<style lang="scss">
  @import '@/assets/style.scss';
</style>
